import { ACTION_REWARD_HISTORY, ACTION_REWARD_HISTORY_ERROR, ACTION_REWARD_HISTORY_SUCCESS } from "."
import * as api from "../../../api"
import * as authActions from "../../auth/actions";

export const getRewardHistoryRequest = (access_token, url) => ({
    type: ACTION_REWARD_HISTORY,
    payload: {
        access_token,
        url
    }
})

export const getRewardHistorySuccess = data => ({
    type: ACTION_REWARD_HISTORY_SUCCESS,
    payload: {
        data
    }
})


export const getRewardHistoryError = (msg) => ({
    type: ACTION_REWARD_HISTORY_ERROR,
    payload: {
        msg
    }
})

export const getRewardHistory = (access_token, url) => {
    return dispatch => {
        dispatch(getRewardHistoryRequest(access_token, url))
        api.getRewardHistory(access_token, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(getRewardHistoryError("error"));
                    return
                }

                const {lists} = data
                dispatch(getRewardHistorySuccess(lists));
            }).catch((err) => {

                console.log(err)

                if (err.response) {
                    if (err.response.status === 401) {
                        dispatch(authActions.logout())
                        return
                    }
                }

                dispatch(getRewardHistoryError("system error"))
            });
    }
}